import React from "react";
import "./SegmentedControl.css";

export default function SegmentedControl({ options, value, onChange }) {
  return (
    <div className="segmented-control">
      {options.map((opt, index) => (
        <button
          key={opt}
          className={`segment Satoshi ${value === opt ? "active" : ""}`}
          onClick={() => onChange(opt)}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
